import React, { useState } from "react";
import {
	MergeTagVariable,
	AddMergeTagVariableFormValues
} from "@/Contracts/Documents";
import { FormComponentProps } from "@ant-design/compatible/lib/form/Form";
import Form from "@ant-design/compatible/lib/form/Form";
import { Row, Input, Col, Button, Dropdown } from "antd";

export interface Props
	extends FormComponentProps<AddMergeTagVariableFormValues> {
	mergeTagVariableSelected: MergeTagVariable | null;
	onSubmit?: (mergeTagVariable: MergeTagVariable) => void;
	onClose?: () => void;
	mergeTagCustomVariables: MergeTagVariable[];
	updateMergeTagVariables: (
		mergeTagVariables: MergeTagVariable[]
	) => Promise<void>;
}

const MergeTagEditPopup: React.FC<Props> = ({
	form,
	mergeTagVariableSelected,
	mergeTagCustomVariables = [],
	updateMergeTagVariables,
	onSubmit,
	onClose
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const onCancel = (
		_: React.MouseEvent<any> | React.KeyboardEvent<HTMLDivElement>
	) => {
		if (onClose) {
			onClose();
		}
	};
	const onSave = ($event: React.FormEvent<HTMLFormElement>) => {
		$event.preventDefault();
		form.validateFields(
			(
				errors: unknown,
				addVariableFormValues: AddMergeTagVariableFormValues
			) => {
				if (!errors) {
					editVariable($event, addVariableFormValues);
				}
			}
		);
	};

	const editVariable = async (
		_: React.FormEvent<HTMLFormElement>,
		addVariableFormValues: AddMergeTagVariableFormValues
	) => {
		setIsLoading(true);
		try {
			if (mergeTagVariableSelected) {
				const customMergeTagVariablesWithoutCurrent =
					mergeTagCustomVariables.filter(
						mTC =>
							mTC.variable_name !==
							mergeTagVariableSelected?.variable_name
					);
				const newMergeTagVariable: MergeTagVariable = {
					...mergeTagVariableSelected,
					value: addVariableFormValues.value
				};
				await updateMergeTagVariables([
					...customMergeTagVariablesWithoutCurrent,
					newMergeTagVariable
				]);
				onSubmit && onSubmit(newMergeTagVariable);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<Dropdown
			visible={!!mergeTagVariableSelected}
			className="merge_tag-edit-dropdown"
			key={mergeTagVariableSelected?.variable_name}
			overlayClassName="merge_tag-edit-dropdown"
			overlay={
				<>
					<Form
						labelCol={{ span: 24 }}
						wrapperCol={{ span: 24 }}
						onSubmit={onSave}
						className="edit-variable-form"
					>
						<Row className="edit-variable-form-container">
							<Col span={24}>
								<Form.Item
									label="Variable value"
									hasFeedback={true}
								>
									{form.getFieldDecorator("value", {
										rules: [
											{
												required: true,
												message: "Enter variable value",
												whitespace: true
											}
										],
										initialValue:
											mergeTagVariableSelected &&
											mergeTagVariableSelected.value
									})(
										<Input placeholder="Enter variable value" />
									)}
								</Form.Item>
							</Col>
						</Row>
						<div className="popup-footer">
							<Button
								key="submit"
								type="primary"
								htmlType="submit"
								disabled={isLoading}
								loading={isLoading}
							>
								Save
							</Button>
							<Button
								key="cancel"
								type="link"
								onClick={onCancel}
								disabled={isLoading}
							>
								Cancel
							</Button>
						</div>
					</Form>
				</>
			}
		>
			<div></div>
		</Dropdown>
	);
};

export default Form.create<Props>({ name: "edit_variable_form" })(
	MergeTagEditPopup
);
